import { Route, Routes, useNavigate } from 'react-router-dom';

import Contracts from '../contracts';
import Counterparties from '../counterparties/Counterparties';
import Infopanel from '../infopanel/Infopanel';
import Organizations from '../organization/Organization';
import PowersAttorney from '../powers-attorney/PowersAttorney';
import Settings from '../settings/Settings';
import { Staff } from '../staff/Staff';

import { Profile } from '../profile/Profile';

import { CounterpatyDetail } from '../counterparties/counterparty-detail/CounterpatyDetail';
import { InvitationContent } from '../invitation';

import { AppRoutes } from 'config/routes';

import { useLimits } from 'hooks';
import { useEffect } from 'react';
import CustomWidget from '../custom-widget';
import Employees from '../employee-management';
import ControlCards from '../fuel-supply/control-cards';
import OperationalRequests from '../fuel-supply/operational-requests';
import ShipmentRegistry from '../fuel-supply/shipment-registry';
import ShipmentReports from '../fuel-supply/shipment-reports';
import NewShipmentRegistry from '../fuel-supply/shipment-reports/new/New';
import ShipmentTasks from '../fuel-supply/shipment-tasks';
import { OrganizationProfile } from '../organization-profile/OrganizationProfile';
import s from './DashboardPage.module.scss';

export function DashboardPage() {
  const navigate = useNavigate();
  const { isFetching, isLimitedUser } = useLimits();

  const {
    Profile: ProfileRoute,
    Settings: SettingsRoute,
    Contracts: ContractsRoute,
    Infopanel: InfopanelRoute,
    Organizations: OrganizationRoute,
    ShipmentTasks: ShipmentTasksRoute,
    ShipmentReports: ShipmentReportsRoute,
    ControlCards: ControlCardsRoute,
    Counterparties: CounterpartiesRoute,
    PowersAttorney: PowersAttorneyRoute,
    OrganizationProfile: OrganizationProfileRoute,
    OperationalRequests: OperationalRequestsRoute,
    CustomWidget: CustomWidgetRoute,
    ShipmentRegistry: ShipmentRegistryRoute,
    Employees: EmployeesRoute, 
  } = AppRoutes.Dashboard;

  useEffect(() => {
    if (!isFetching && isLimitedUser) {
      if (!window.location.pathname.includes(PowersAttorneyRoute.Home)) {
        // navigate(PowersAttorneyRoute.Home + PowersAttorneyRoute.Active);
        navigate(AppRoutes.Auth.Home + AppRoutes.Auth.UserRestricted);
      }
    }
  }, [isFetching, isLimitedUser]);

  return (
    <div className={s.container}>
      <Routes>
        <Route path={InfopanelRoute + '/*'} element={<Infopanel />} />
        <Route path={CounterpartiesRoute.Home + '/*'} element={<Counterparties />} />
        <Route
          path={
            CounterpartiesRoute.Home +
            CounterpartiesRoute.CounterpatyDetail.Home +
            '/:id' +
            '/*'
          }
          element={<CounterpatyDetail />}
        />
        <Route
          path={CounterpartiesRoute.Home + CounterpartiesRoute.Invitation.Home + '/*'}
          element={<InvitationContent />}
        />
        <Route path={ContractsRoute.Home + '/*'} element={<Contracts />} />
        <Route path={PowersAttorneyRoute.Home + '/*'} element={<PowersAttorney />} />

        <Route path={ProfileRoute.Home + '/*'} element={<Profile />} />
        <Route
          path={OrganizationProfileRoute.Home + '/:id'}
          element={<OrganizationProfile />}
        />
        <Route path={OrganizationRoute.Home + '/*'} element={<Organizations />} />
        <Route
          path={OrganizationRoute.Home + OrganizationRoute.Staff + '/*'}
          element={<Staff />}
        />
        <Route path={CustomWidgetRoute.Home + '/*'} element={<CustomWidget />} />
        <Route path={EmployeesRoute.Home + '/*'} element={<Employees />} />

        <Route path={OperationalRequestsRoute.Home + '/*'} element={<OperationalRequests />} />
        <Route path={ShipmentTasksRoute.Home + '/*'} element={<ShipmentTasks />} />
        <Route path={ControlCardsRoute.Home + '/*'} element={<ControlCards />} />

        <Route path={ShipmentReportsRoute.Home + '/*'} element={<ShipmentReports />} />
        <Route path={ShipmentReportsRoute.New + '/*'} element={<NewShipmentRegistry />} />

        <Route path={ShipmentRegistryRoute.Home + '/*'} element={<ShipmentRegistry />} />
        <Route
          path={SettingsRoute.Home + SettingsRoute.EDOOperator + '/*'}
          element={<Settings />}
        />
      </Routes>
    </div>
  );
}
